import { Injectable } from '@angular/core';
import { Breed, BreedSummary } from './breed';
import {
    BaseIndexedDbRepository,
    SynchronizationService
} from 'libs/arch/src/lib/repositories/indexed-db';
import { NgxIndexedDBService } from 'ngx-indexed-db';

@Injectable({ providedIn: 'root' })
export class BreedsRepository extends BaseIndexedDbRepository<BreedSummary, Breed> {
    protected override readonly storeName: string = 'breeds';

    constructor(
        dbService: NgxIndexedDBService,
        synchronizationService: SynchronizationService
    ) {
        super(dbService, synchronizationService);
    }

    protected override mapToEntity(dbItem: Breed): Breed {
        return Breed.fromJson(dbItem);
    }

    protected override mapToSummary(entity: Breed): BreedSummary {
        return new BreedSummary(entity.id, entity.description, entity.showInApp);
    }

    protected override getSearchableFields(): string[] {
        return ['description'];
    }

    protected override getResourcePath(): string {
        return 'breeds';
    }
}
